"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  index: "S.01",
  title: "Sell-Side M&A Advisory",
  description: "We orchestrate competitive exit processes for founders and shareholders. By positioning your business legacy within the context of current market demand, we ensure maximum valuation and optimal deal terms for $2M–$30M enterprises.",
  linkLabel: "View our process",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/ma_advisory_boardroom.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/ma_advisory_boardroom.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/ma_advisory_boardroom.webp-wvc-sizes",
    alt: "Modern boardroom overlooking the Pacific ocean during a strategic M&A session",
    label: "M&A STRATEGY"
  },
  imageRight: true
}, {
  index: "S.02",
  title: "Capital Raises",
  description: "Securing growth capital requires a narrative that resonates with institutional investors. We leverage our network to connect your firm with the right partners, ensuring your capital structure supports long-term scalability and value creation.",
  linkLabel: "Explore capital solutions",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/capital_raise_dashboard.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/capital_raise_dashboard.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/capital_raise_dashboard.png-wvc-sizes",
    alt: "Financial dashboard showing capital allocation and growth projections",
    label: "CAPITAL / 04:32"
  },
  imageRight: false
}, {
  index: "S.03",
  title: "Investment Mandates",
  description: "BPV actively pursues direct investment opportunities in companies with $1M–$5M EBITDA. Our mandate focuses on sectors where we provide not just capital, but operational expertise to drive sustainable growth and market leadership.",
  linkLabel: "Review investment criteria",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/investment_mandate_map.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/investment_mandate_map.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/investment_mandate_map.png-wvc-sizes",
    alt: "Investment mandate map highlighting key sectors and regional focus areas",
    label: "MANDATE / BPV-01"
  },
  imageRight: true
}];
function CornerTicks() {
  return <>
      <span className="pointer-events-none absolute -top-px -left-px h-2.5 w-2.5 border-t border-l border-[var(--primary)]" aria-hidden="true" />
      <span className="pointer-events-none absolute -top-px -right-px h-2.5 w-2.5 border-t border-r border-[var(--primary)]" aria-hidden="true" />
      <span className="pointer-events-none absolute -bottom-px -left-px h-2.5 w-2.5 border-b border-l border-[var(--primary)]" aria-hidden="true" />
      <span className="pointer-events-none absolute -bottom-px -right-px h-2.5 w-2.5 border-b border-r border-[var(--primary)]" aria-hidden="true" />
    </>;
}
function VioletBeam({
  className = ""
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-2 ${className}`} aria-hidden="true">
      <div className="h-px flex-1 bg-border" />
      <div className="h-1.5 w-1.5 rounded-md bg-[var(--primary)]" />
    </div>;
}
export default function Keyriskfactors() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}